export default "/images/check2-square.svg?c602898f4d0f083351c2719d5577f4e0";